<template>
    <div>
        <chart v-if="isLoaded"
            :game-id="gameId"
            :selected-symbols="selectedSymbols"
            @selectSymbol="selectSymbol">
        </chart>
        <div class="mt-2 mb-2">
            <span>{{ 'stats.lucky_guessed_desc' | lang }}</span>
        </div>
        <div class="text-center">
            <b-button v-if="isLogged"
                variant="success"
                @click="useSymbols"
                class="font-weight-semi-bold"
                :disabled='!selectedSymbols.length'>
                <template v-if="game.name == 'Dice'">
                    {{ 'use_symbols_dice' | lang }}
                </template>
                <template v-else>
                    {{ 'use_symbols' | lang }}
                </template>
            </b-button>
            <b-button variant="outline-dark" :to="{ name: 'results' }" class="font-weight-semi-bold results-button">{{ 'results' | lang }}</b-button>
        </div>
        <div class="mt-2 alert alert-success text-center" v-if="infoText">
            <span> {{ infoText }} </span>
        </div>
    </div>
</template>

<script>
import Chart from './Chart';
import lang from '@tv/filters/lang';
import { mapState } from 'vuex';
import { last } from 'lodash';

import { syncFrameHeight } from "@tv/helpers";

export default {
    props: ['gameId'],

    components: { Chart },

    data() {
        return {
            selectedSymbols: [],
            alertTimeout: null,
            infoText: null,
        };
    },

    computed: {
        ...mapState(['channels', 'isLogged']),

        game() {
            return Config.games[this.gameId];
        },

        isLoaded() {
            return Object.keys(this.channels).length > 0;
        },

        selectionLimit() {
            const counts = this.game.counts;
            
            if(this.game.name === 'Dice') {
                return 1;
            }

            return last(Object.values(counts).map(item => item.count).sort((a, b) => a - b));
        },
    },

    methods: {
        selectSymbol(id) {
            if (this.selectedSymbols.includes(id)) {
                this.selectedSymbols = this.selectedSymbols.filter(itemId => id != itemId);
            } else {
                this.selectedSymbols.push(id);
            }

            while (this.selectedSymbols.length > this.selectionLimit) {
                this.selectedSymbols.shift();
            }

            if (this.game.name == 'Jokerjackpot') {
                const flasked = {};

                for (const itemId of this.selectedSymbols) {
                    flasked[this.game.items[itemId].flask] = itemId;
                }

                this.selectedSymbols = Object.values(flasked);
            }
        },

        useSymbols() {
            this.$emit('useSymbols', this.selectedSymbols);
            this.selectedSymbols = [];
            this.setAlert(this.$options.filters.lang('use_symbols_done'));
        },

        setAlert(alert) {
            clearTimeout(this.alertTimeout);

            this.infoText = alert;

            this.alertTimeout = setTimeout(() => {
                this.infoText = null;
                this.$nextTick(() => syncFrameHeight());
            }, 3000);

            this.$nextTick(() => syncFrameHeight());
        },
    },
}
</script>